import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "product-list row row-cols-1 row-cols-md-2 row-cols-lg-4 mx-0 g-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_card = _resolveComponent("product-card")!
  const _component_infinite_scroll = _resolveComponent("infinite-scroll")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_mq_responsive = _resolveComponent("mq-responsive")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: product.id,
          class: "col"
        }, [
          _createVNode(_component_product_card, {
            product: product,
            onTryIt: ($event: any) => (_ctx.tryItHandler($event, idx))
          }, null, 8, ["product", "onTryIt"])
        ]))
      }), 128))
    ]),
    _createVNode(_component_mq_responsive, null, {
      "md-": _withCtx(() => [
        _createVNode(_component_infinite_scroll, {
          config: _ctx.pagination,
          "onUpdate:config": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
          onBottomReached: _ctx.getProducts
        }, null, 8, ["config", "onBottomReached"])
      ]),
      "lg+": _withCtx(() => [
        (_ctx.products.length)
          ? (_openBlock(), _createBlock(_component_pagination, {
              key: 0,
              class: "d-flex justify-content-center mt-4",
              config: _ctx.pagination,
              "onUpdate:config": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination) = $event)),
              onPageChanged: _ctx.getProducts
            }, null, 8, ["config", "onPageChanged"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}